import { Line } from '@mm/components';
import React from 'react';
import styles from './BarGraph.module.css';
import {
  AVERAGE_WEB_CONVERSION_RATE,
  beautifyNumber,
  WEB_TRAFFIC_GROWTH_WITH_MOBILEMONKEY,
} from '../WebsiteReportSummary/constants';
import classNames from 'classnames';
import { LLRActionButtons } from '../LLRActionButtons/LLRActionButtons';

type Props = {
  buttonName?: string;
  className?: string;
  websiteUrl: string;
  isOrganic?: boolean;
  showTotal?: boolean;
  organicTraffic: number;
  paidTraffic: number;
  onClick: () => void;
  isWhiteLabel?: boolean;
};

// tslint:disable-next-line: cyclomatic-complexity

export const BarGraph = ({
  isOrganic = false,
  organicTraffic,
  paidTraffic,
  showTotal = false,
  onClick = () => {},
  buttonName = '',
  className = '',
  websiteUrl = '',
  isWhiteLabel,
}: Props) => {
  const currentConvertedLeads = organicTraffic * AVERAGE_WEB_CONVERSION_RATE;
  const totalConvertedLeads =
    (organicTraffic + paidTraffic) * AVERAGE_WEB_CONVERSION_RATE;
  const conversion = WEB_TRAFFIC_GROWTH_WITH_MOBILEMONKEY;

  return (
    <div className={classNames(styles.barGraph, className)}>
      <span className={styles.graphTitle}>
        {' '}
        {isOrganic || showTotal
          ? 'Unique visitor emails captured per month'
          : 'Leads per $100 of media spend'}
      </span>

      <div className={styles.barsWrapper}>
        <div className={styles.bar}>
          <span className={styles.number}>
            <span className={styles.percent}>2%</span>
            {isOrganic || showTotal
              ? beautifyNumber(
                  showTotal ? totalConvertedLeads : currentConvertedLeads,
                )
              : '2'}
          </span>
          <span className={styles.smallBar} />
          <span>{isOrganic || showTotal ? 'Currently' : 'Before'}</span>
        </div>
        <div className={styles.bar}>
          <span className={styles.number}>
            <span className={styles.percent}>20%</span>
            {showTotal
              ? beautifyNumber(
                  organicTraffic * conversion + paidTraffic * conversion,
                )
              : isOrganic
              ? beautifyNumber(organicTraffic * conversion)
              : beautifyNumber(paidTraffic * conversion)}
          </span>
          <span className={styles.bigBar} />
          {(isOrganic || showTotal) && (
            <div className={styles.more}>
              10x <span className={styles.description}>More</span>
            </div>
          )}
          <span>
            {isOrganic || showTotal
              ? isWhiteLabel
                ? 'With us'
                : 'With Customers.ai'
              : 'After'}
          </span>
        </div>
      </div>
      <Line className={styles.graphLine} />
      <div className={styles.descriptionContainer}>
        <div className={styles.descriptionTitle}>
          Know who's visiting <span className={styles.link}>{websiteUrl}</span>{' '}
          without popups or forms!
        </div>
        <div className={styles.descriptionText}>
          {isWhiteLabel ? 'We provide' : 'Customers.ai provides'} contact info
          and insights for up to 20% of your U.S. website visitors.
        </div>
        <div className={styles.descriptionText}>
          Without invasive user experiences like forms or popups.
        </div>
      </div>
      {!isWhiteLabel && (
        <LLRActionButtons
          onClick={onClick}
          buttonName={buttonName}
          websiteURL={websiteUrl}
        />
      )}
    </div>
  );
};
